import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import PublicForge from "@/pages/PublicForge";
import Dashboard from "@/pages/Dashboard";
import Forge from "@/pages/Forge";
import Archives from "@/pages/Archives";
import Fleet from "@/pages/Fleet";
import Stream from "@/pages/Stream";
import Bridge from "@/pages/Bridge";
import Sign from "@/pages/Sign";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";
import { AuthProvider, AdminRoute } from "@/lib/auth.jsx";

function ArmadaRoutes() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Navigate to="/public-forge" replace />} />
        <Route path="/bridge" element={<AdminRoute><Bridge /></AdminRoute>} />
        <Route path="/dashboard" element={<AdminRoute><Dashboard /></AdminRoute>} />
        <Route path="/forge" element={<AdminRoute><Forge /></AdminRoute>} />
        <Route path="/archives" element={<AdminRoute><Archives /></AdminRoute>} />
        <Route path="/archives/:id" element={<AdminRoute><Archives /></AdminRoute>} />
        <Route path="/fleet" element={<AdminRoute><Fleet /></AdminRoute>} />
        <Route path="/stream" element={<AdminRoute><Stream /></AdminRoute>} />
        <Route path="/public-forge" element={<PublicForge />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route path="*" element={<Navigate to="/public-forge" replace />} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/sign/:token" element={<Sign />} />
            <Route path="/*" element={<ArmadaRoutes />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      <Toaster
        theme="dark"
        position="top-right"
        toastOptions={{
          style: {
            background: "rgba(10, 10, 10, 0.95)",
            border: "1px solid rgba(201, 162, 39, 0.3)",
            color: "#fff",
            fontFamily: "Montserrat, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
